module.exports = __webpack_public_path__ + "2abc1d698e24fa8af908c3742bf63078.svg";